import { cn } from '@nucleus-commerce/ui/lib/utils';

/** "12/100" beside a text field; turns red past the network's limit. */
export function TextCounter({ length, max, id }: { length: number; max: number; id?: string }) {
  const over = length > max;
  return (
    <span
      id={id}
      className={cn('text-xs tabular-nums', over ? 'text-destructive' : 'text-muted-foreground')}
      aria-live="polite"
    >
      {`${length}/${max}`}
    </span>
  );
}
